import { ILogger } from '~/packages/core';
import { LogEvents } from '~/services/fullstory/log-events';

let __resolution = null;

const isInBrowserContext = () => {
    // not true when running tests
    return typeof window !== 'undefined';
};

export const getScreenResolution = (logger: ILogger) => {
    if (isInBrowserContext()) {
        const width = window.screen.width * window.devicePixelRatio;
        const height = window.screen.height * window.devicePixelRatio;
        __resolution = `${Math.min(width, height)}x${Math.max(width, height)}`;
    } else {
        __resolution = 'N/A';
        logger.warn(LogEvents.FailedCalcScreenRes);
    }

    return __resolution;
};
